/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useRef, useState} from "react";
import CartAPI from "../../shared/modules/CartAPI";
import LoadingSpinner from "../BuyItNow/components/LoadingSpinner";
import PropTypes from "prop-types";

const PromoCodeField = ({cartInfo, promoCode, setCartInfo, setPromoCode}) => {
  const [
    showPromoCodeField,
    setShowPromoCodeField
  ] = useState(false);
  const [
    promoCodeMessage,
    setPromoCodeMessage
  ] = useState(null);
  const [
    promoCodeMessageClass,
    setPromoCodeMessageClass
  ] = useState(null);
  const [
    loading,
    setLoading
  ] = useState(false);

  const handleManuallyAppliedPromoCode = (appliedCode) => {
    const detail = {"detail": {"promoCode": appliedCode}};
    const customEvent = new CustomEvent("appliedPromoCode", detail);
    window.dispatchEvent(customEvent);
  };

  const refreshCartInfo = () => {
    setLoading(true);
    CartAPI.getCartInfo(promoCode).then((response) => {
      setCartInfo(response.preview);
      if (response.preview.promo_code_error) {
        setPromoCodeMessage(response.preview.promo_code_error);
        setPromoCodeMessageClass("promo-code-error");
      } else {
        setPromoCodeMessage(
          `Successfully applied promo code ${promoCode.toUpperCase()} to eligible items. Promo exclusions apply.`
        );
        setPromoCodeMessageClass("promo-code-success");
      }
      handleManuallyAppliedPromoCode(response.preview.promo_code_error ? "" : promoCode);
    });
    setLoading(false);
  };

  const usePreviousValue = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const prevPromoCode = usePreviousValue(promoCode);
  useEffect(() => {
    if (prevPromoCode && !promoCode && !showPromoCodeField) {
      refreshCartInfo();
      setShowPromoCodeField(true);
    }
  }, [promoCode]);

  useEffect(() => {
    if (promoCodeMessage) {
      setShowPromoCodeField(true);
    }
  }, [promoCodeMessage]);

  const handlePromoApplication = () => {
    refreshCartInfo();
    setShowPromoCodeField(false);
  };

  const handleApplyDifferentCode = () => {
    setPromoCode(null);
  };


  return (
    <div className="cart-block promo-code-field-component">
      <div className="header">
        <div className="title">
          promo code
        </div>
        {!showPromoCodeField && !promoCode &&
          <div className="add-promo-code">
            <div
              className="increase-btn increase-quantity-button"
              onClick={() => setShowPromoCodeField(!showPromoCodeField)}
              type="button"
            />
          </div>
        }

        {!showPromoCodeField && promoCode &&
          <div
            className="underline"
            onClick={() => {
              handleApplyDifferentCode();
            }}
          >
            Apply a different code
          </div>
        }
      </div>
      {promoCodeMessage &&
        <div className={`promo-code-msg ${promoCodeMessageClass}`}>
          {promoCodeMessage}
        </div>
      }
      {showPromoCodeField &&
        <div className="promo-field-container">
          <div className="promo-code-field">
            <input
              onChange={event => setPromoCode(event.target.value)}
              onClick={() => setPromoCodeMessage(null)}
              placeholder="Enter promo code"
              type="text"
              value={cartInfo.promoCode}
            />
          </div>
          <div className="promo-code-apply">
            <button
              className="btn btn-primary"
              disabled={loading}
              onClick={() => handlePromoApplication()}
              type="button"
            >
              {loading ? <LoadingSpinner /> : "Apply"}
            </button>
          </div>
        </div>
      }
    </div>
  );
};

PromoCodeField.propTypes = {
  "cartInfo": PropTypes.object.isRequired,
  "promoCode": PropTypes.string.isRequired,
  "setCartInfo": PropTypes.func.isRequired,
  "setPromoCode": PropTypes.func.isRequired
};

export default PromoCodeField;

